define.alias("shared/components/shared/ui/list-uploaded-items", "settings/components/shared/ui/list-uploaded-items");